import React from 'react';
import SFooterDrawer from './SFooterDrawer';
import StripePaymentForm from './StripePaymentForm';
import SLoader from '../atoms/SLoader';
import type { PaymentIntentBooking } from '@/services/stripe.service';

export interface BookingPaymentDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  locationId: string;
  price: number; // Price from booking type in cents
  email: string;
  memberId: string;
  /** What is being booked, so the Stripe charge names the drop-in
   *  rather than showing a bare amount. */
  booking?: PaymentIntentBooking;
  onPaymentSuccess: (paymentId: string) => void;
  /** Payment failed — the caller cancels the booking it already created. */
  onPaymentError?: (message: string) => void;
  isCreatingBooking?: boolean;
}

export const BookingPaymentDrawer: React.FC<BookingPaymentDrawerProps> = ({
  isOpen,
  onClose,
  locationId,
  price,
  email,
  memberId,
  booking,
  onPaymentSuccess,
  onPaymentError,
  isCreatingBooking = false,
}) => {
  return (
    <SFooterDrawer
      isOpen={isOpen}
      onClose={onClose}
      title="Payment"
      height="auto"
      className="booking-checkout-drawer payment-drawer"
    >
      <div className="booking-checkout" style={{ position: 'relative' }}>
        {/* Payment Section */}
        <div className="payment-section">
          <StripePaymentForm
            email={email}
            amount={price}
            currency="usd"
            memberId={memberId}
            locationId={locationId}
            booking={booking}
            onPaymentSuccess={onPaymentSuccess}
            onPaymentError={onPaymentError}
          />
        </div>

        {/* Booking Loader Overlay */}
        {isCreatingBooking && (
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(255, 255, 255, 0.9)',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 10,
            }}
          >
            <SLoader />
            <p style={{ margin: '16px 0 0 0', fontSize: '14px', color: '#000' }}>
              Creating your booking...
            </p>
          </div>
        )}
      </div>
    </SFooterDrawer>
  );
};

export default BookingPaymentDrawer;
